import {RegistrationPreferencesModal} from "../../../auth/components/registration_flow/RegistrationPreferencesModal";
import {useHomeMatchBasicPreferencesFlow} from "../../hooks/use_home_match_basic_preferences_flow";
import {IHomeMatchBasicPreferencesFlowProps} from "../../types/HomeMatchBasicPreferencesFlowTypes";
import {getHomeMatchBasicSurveyCopy} from "../../utils/home_match_basic_preferences_flow_utils";
import {HomeMatchBasicPreferencesFlowLoadingModal} from "./HomeMatchBasicPreferencesFlowLoadingModal";
import {HomeMatchBasicPreferencesFlowPhoneUpdateModal} from "./HomeMatchBasicPreferencesFlowPhoneUpdateModal";
import {HomeMatchBasicPreferencesFlowPhoneVerificationModal} from "./HomeMatchBasicPreferencesFlowPhoneVerificationModal";
import {HomeMatchBasicPreferencesFlowResignationModal} from "./HomeMatchBasicPreferencesFlowResignationModal";
import {HomeMatchBasicPreferencesFlowSummaryModal} from "./HomeMatchBasicPreferencesFlowSummaryModal";

export const HomeMatchBasicPreferencesFlow = (props: IHomeMatchBasicPreferencesFlowProps) => {
    const {
        isOpen,
        source,
        defaultHomeMatchBasicConsent,
        initialStep = "auto",
        propertyId,
        offerId,
        originalApplicationResponse,
        trackingContext,
        onComplete
    } = props;
    const flow = useHomeMatchBasicPreferencesFlow({
        isOpen,
        source,
        defaultHomeMatchBasicConsent,
        initialStep,
        propertyId,
        offerId,
        originalApplicationResponse,
        onComplete
    });

    if (!isOpen) {
        return null;
    }

    if (flow.step === "completed") {
        return null;
    }

    if (flow.step === "resolving" || flow.isLoading || flow.isHomeMatchConfigurationLoading) {
        return <HomeMatchBasicPreferencesFlowLoadingModal isOpen={isOpen} />;
    }

    if (flow.step === "survey") {
        const surveyCopy = getHomeMatchBasicSurveyCopy(flow.isEditingSurvey);

        return (
            <RegistrationPreferencesModal
                isOpen={isOpen}
                isPropertyApplication={Boolean(propertyId)}
                propertyId={propertyId}
                offerId={offerId || undefined}
                application={originalApplicationResponse}
                surveySource={flow.surveySource}
                title={surveyCopy.title}
                description={surveyCopy.description}
                submitButtonText={flow.isEditingSurvey ? "ZAPISZ" : "ZAPISZ SWOJE PREFERENCJE"}
                closeButtonText={surveyCopy.closeButtonText}
                onCancel={flow.isEditingSurvey ? flow.handleSurveyCancel : undefined}
                overrideDefaultValues={flow.isEditingSurvey ? flow.summaryValues : undefined}
                onSuccess={flow.handleSurveySuccess}
                showPriceHeader={!flow.isEditingSurvey}
                showMarketingConsents={!flow.isEditingSurvey}
                showCreditPlan={!flow.isEditingSurvey}
                layoutVariant={flow.isEditingSurvey ? "homeMatchBasicEdit" : "homeMatchBasicSurvey"}
                gtmEventCategory={flow.isEditingSurvey ? trackingContext?.eventCategory : undefined}
                gtmCustomLabel={flow.isEditingSurvey ? (trackingContext?.sourceModal ?? trackingContext?.eventName) : undefined}
            />
        );
    }

    if (flow.step === "resignation") {
        return (
            <HomeMatchBasicPreferencesFlowResignationModal
                isOpen={isOpen}
                isSaving={flow.isSaving}
                onDisable={() => flow.saveHomeMatchDecision(false, "stayModal")}
                onKeepEnabled={flow.handleKeepEnabled}
                onClose={flow.handleResignationClose}
                trackingContext={trackingContext}
            />
        );
    }

    if (flow.step === "phoneVerification") {
        return (
            <HomeMatchBasicPreferencesFlowPhoneVerificationModal
                isOpen={isOpen}
                onClose={flow.handlePhoneVerificationClose}
                onSuccess={flow.handlePhoneVerificationSuccess}
                onChangeNumber={flow.handlePhoneVerificationChangeNumber}
            />
        );
    }

    if (flow.step === "phoneUpdate") {
        return (
            <HomeMatchBasicPreferencesFlowPhoneUpdateModal isOpen={isOpen} onClose={flow.handlePhoneUpdateClose} onSuccess={flow.handlePhoneUpdateSuccess} />
        );
    }

    return (
        <HomeMatchBasicPreferencesFlowSummaryModal
            isOpen={isOpen}
            source={source}
            values={flow.summaryValues}
            regionDetails={flow.regionDetails}
            homeMatchBasicConsent={flow.homeMatchBasicConsent}
            isSaving={flow.isSaving}
            onHomeMatchBasicConsentChange={flow.setHomeMatchBasicConsent}
            onEditPreferences={flow.handleEditPreferences}
            onConfirm={flow.handleSummaryConfirm}
            onClose={flow.handleSummaryClose}
            trackingContext={trackingContext}
        />
    );
};
import {RegistrationPreferencesModal} from "../../../auth/components/registration_flow/RegistrationPreferencesModal";
import {useHomeMatchBasicPreferencesFlow} from "../../hooks/use_home_match_basic_preferences_flow";
import {IHomeMatchBasicPreferencesFlowProps} from "../../types/HomeMatchBasicPreferencesFlowTypes";
import {getHomeMatchBasicSurveyCopy} from "../../utils/home_match_basic_preferences_flow_utils";
import {HomeMatchBasicPreferencesFlowLoadingModal} from "./HomeMatchBasicPreferencesFlowLoadingModal";
import {HomeMatchBasicPreferencesFlowPhoneUpdateModal} from "./HomeMatchBasicPreferencesFlowPhoneUpdateModal";
import {HomeMatchBasicPreferencesFlowPhoneVerificationModal} from "./HomeMatchBasicPreferencesFlowPhoneVerificationModal";
import {HomeMatchBasicPreferencesFlowResignationModal} from "./HomeMatchBasicPreferencesFlowResignationModal";
import {HomeMatchBasicPreferencesFlowSummaryModal} from "./HomeMatchBasicPreferencesFlowSummaryModal";

export const HomeMatchBasicPreferencesFlow = (props: IHomeMatchBasicPreferencesFlowProps) => {
    const {
        isOpen,
        source,
        defaultHomeMatchBasicConsent,
        initialStep = "auto",
        propertyId,
        offerId,
        originalApplicationResponse,
        trackingContext,
        onComplete
    } = props;
    const flow = useHomeMatchBasicPreferencesFlow({
        isOpen,
        source,
        defaultHomeMatchBasicConsent,
        initialStep,
        propertyId,
        offerId,
        originalApplicationResponse,
        onComplete
    });

    if (!isOpen) {
        return null;
    }

    if (flow.step === "completed") {
        return null;
    }

    if (flow.step === "resolving" || flow.isLoading || flow.isHomeMatchConfigurationLoading) {
        return <HomeMatchBasicPreferencesFlowLoadingModal isOpen={isOpen} />;
    }

    if (flow.step === "survey") {
        const surveyCopy = getHomeMatchBasicSurveyCopy(flow.isEditingSurvey);

        return (
            <RegistrationPreferencesModal
                isOpen={isOpen}
                isPropertyApplication={Boolean(propertyId)}
                propertyId={propertyId}
                offerId={offerId || undefined}
                application={originalApplicationResponse}
                surveySource={flow.surveySource}
                title={surveyCopy.title}
                description={surveyCopy.description}
                submitButtonText={flow.isEditingSurvey ? "ZAPISZ" : "ZAPISZ SWOJE PREFERENCJE"}
                closeButtonText={surveyCopy.closeButtonText}
                onCancel={flow.isEditingSurvey ? flow.handleSurveyCancel : undefined}
                overrideDefaultValues={flow.isEditingSurvey ? flow.summaryValues : undefined}
                onSuccess={flow.handleSurveySuccess}
                showPriceHeader={!flow.isEditingSurvey}
                showMarketingConsents={!flow.isEditingSurvey}
                showCreditPlan={!flow.isEditingSurvey}
                layoutVariant={flow.isEditingSurvey ? "homeMatchBasicEdit" : "homeMatchBasicSurvey"}
                gtmEventCategory={flow.isEditingSurvey ? trackingContext?.eventCategory : undefined}
                gtmCustomLabel={flow.isEditingSurvey ? (trackingContext?.sourceModal ?? trackingContext?.eventName) : undefined}
            />
        );
    }

    if (flow.step === "resignation") {
        return (
            <HomeMatchBasicPreferencesFlowResignationModal
                isOpen={isOpen}
                isSaving={flow.isSaving}
                onDisable={() => flow.saveHomeMatchDecision(false, "stayModal")}
                onKeepEnabled={flow.handleKeepEnabled}
                onClose={flow.handleResignationClose}
                trackingContext={trackingContext}
            />
        );
    }

    if (flow.step === "phoneVerification") {
        return (
            <HomeMatchBasicPreferencesFlowPhoneVerificationModal
                isOpen={isOpen}
                onClose={flow.handlePhoneVerificationClose}
                onSuccess={flow.handlePhoneVerificationSuccess}
                onChangeNumber={flow.handlePhoneVerificationChangeNumber}
            />
        );
    }

    if (flow.step === "phoneUpdate") {
        return (
            <HomeMatchBasicPreferencesFlowPhoneUpdateModal isOpen={isOpen} onClose={flow.handlePhoneUpdateClose} onSuccess={flow.handlePhoneUpdateSuccess} />
        );
    }

    return (
        <HomeMatchBasicPreferencesFlowSummaryModal
            isOpen={isOpen}
            source={source}
            values={flow.summaryValues}
            regionDetails={flow.regionDetails}
            homeMatchBasicConsent={flow.homeMatchBasicConsent}
            isSaving={flow.isSaving}
            onHomeMatchBasicConsentChange={flow.setHomeMatchBasicConsent}
            onEditPreferences={flow.handleEditPreferences}
            onConfirm={flow.handleSummaryConfirm}
            onClose={flow.handleSummaryClose}
            trackingContext={trackingContext}
        />
    );
};
